<template>
    <b-button variant="danger" size="sm" @click="confirmDelete">
        <i class="fas fa-trash-alt fa-fw"></i> Supprimer les échéances cochées
    </b-button>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'MultiDeadlineDeleteHandler',

    data() {
        return {
            form: {},
        }
    },

    computed: {
        ...mapState({
            checkedDeadlines: (state) => state.data.checkedDeadlines,
        }),

        modalMessage() {
            return this.checkedDeadlines.length === 1
                ? 'Etes-vous sûr·e de vouloir supprimer cette échéance ?'
                : `Etes-vous sûr·e de vouloir supprimer ces ${this.checkedDeadlines.length} échéances ?`
        },
    },

    methods: {
        async deleteDeadlines() {
            this.form.deadlines = this.checkedDeadlines
            console.log('checkedDeadlines', this.checkedDeadlines)
            try {
                await axios.post('/clientDeadlines/multi-delete', this.form)
                this.$store.commit('data/RESET_CHECKED_DEADLINES')
                await this.$parent.getItems()
            } catch (error) {
                console.log(error)
            }
        },

        confirmDelete() {
            this.$bvModal
                .msgBoxConfirm(this.modalMessage, {
                    title: "Suppression d'échéances",
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OUI',
                    cancelTitle: 'NON',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.deleteDeadlines()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },
    },
}
</script>

<style scoped></style>
